import { ErrorResponse } from "@apollo/client/link/error"

export const errorMessagesMap: Record<string, string> = {
  "Tenant has assigned users": "Nie można usunąć podmiotu posiadającego aktywnych użytkowników.",
}

export const getMessageErrorTranslation: (message: string) => string = (message: string) => {
  return errorMessagesMap[message] || ""
}

export const getExceptionMessageErrorTranslation = (error: ErrorResponse): string => {
  if (error.graphQLErrors && error.graphQLErrors.length && error.graphQLErrors[0].message) {
    return getMessageErrorTranslation(error.graphQLErrors[0].message)
  }
  return ""
}